import { Webinar } from 'src/app/models/oem-models';
import { Component, Input, OnInit } from '@angular/core';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-webinar-user',
  templateUrl: './webinar-user.component.html',
  styleUrls: ['./webinar-user.component.scss']
})
export class WebinarUserComponent implements OnInit {
  @Input() selectedTabIndex:number=0;

  webinars: any[] = [];
  displayWebinars: any;
  userId: string = '';
  userDetails: any;
  tabName: string = 'upcomingwebinar';
  originalTruncateText: number = 24;

  constructor(
    private router: Router,
    private webinarService: WebinarService, 
    private localStorageService: LocalStorageService,
    private breakpointObserver: BreakpointObserver
  ){}

  ngOnInit(): void {
    this.showAllBreakPoints();
    this.userDetails = (this.localStorageService.getItem('userDetails'))
    if (this.userDetails) {
      this.userDetails = JSON.parse(this.userDetails);
      this.userId = this.userDetails.userId || '';
    }
    this.getWebinars(this.userId);
  }

  viewWebinar(webinar: any){
    
    this.router.navigate(['/webinars/view', webinar.id]);

    
  }
  
  getWebinars(id: string){
    this.webinarService.getRegWebinars(id).subscribe((res: any) => {
      this.webinars = res.data;
      this.activateCurrentab('upcomingwebinar')
    });
  }
  showAllBreakPoints() {
    this.breakpointObserver.observe([
      "(min-width: 1540px)",
      "(max-width: 1540px)",
      "(min-width: 1302px) and (max-width: 1390px)",
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints["(min-width: 1540px)"]) {
          this.originalTruncateText =65;
        }
        else if (result.breakpoints["(max-width: 1540px)"]) {
          this.originalTruncateText = 60;
        }
        else if (result.breakpoints["(min-width: 1302px) and (max-width: 1390px)"]) {
          this.originalTruncateText = 35;
        }
      }
    });
  }

  activateCurrentab(selectedName: string): void{
    this.tabName = selectedName;
    if(selectedName === 'upcomingwebinar'){
      this.displayWebinars = this.webinars.filter(webinar => 
        (!webinar?.webinarDate || !webinar?.webinarTime) || (new Date(`${webinar.webinarDate} ${webinar.webinarTime}`) > new Date())
      );
      }
    else{
      this.displayWebinars = this.webinars.filter(webinar => 
        (webinar?.webinarDate && webinar?.webinarTime) ? (new Date(`${webinar.webinarDate} ${webinar.webinarTime}`) <= new Date()) : false
      )
    }
  }
}
